<template>
  <loader v-bind="{ loading }">
    <div class="columns">
      <div class="column">
        <h3 class="title is-4 is-marginless">{{ audit.environment.name }}</h3>
        <p class="class-name">Audit #{{ audit.number }}, {{ audit.created_at | asCalendar }}</p>
      </div>
      <div class="column is-narrow is-flex align-center">
        <manager-actions />
      </div>
    </div>
    <overview />
    <findings />
  </loader>
</template>

<script>
import { mapGetters } from 'vuex'
import Processes from './Processes'
import Overview from './StandardOverview'
import Findings from './Findings'
import ManagerActions from './ManagerActions'

export default {
  components: {
    Processes,
    Overview,
    Findings,
    ManagerActions
  },

  data: () => ({
    loading: true,
    downloading: false,
    deleting: false
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Audit Manager')
    this.$store
      .dispatch('audit/loadAppAudit', {
        app_id: this.$route.params.app,
        audit_id: this.$route.params.audit
      })
      .finally(() => (this.loading = false))
  },

  created() {
    Echo.private(this.broadcastChannel).listen('AuditProcessCompleted', (event) => {
      this.$store.dispatch('audit/loadAppAudit', {
        app_id: this.$route.params.app,
        audit_id: this.$route.params.audit
      })
    })
  },

  beforeDestroy() {
    Echo.leaveChannel(this.broadcastChannel)
  },

  computed: {
    ...mapGetters('audit', [
      'audit',
      'checkpoints'
    ]),
    ...mapGetters('app', [
      'app'
    ]),
    broadcastChannel() {
      return `audits.${this.$route.params.audit}`
    },
    findings() {
      return this.audit.findings.filter(finding => !finding.is_compliant)
    }
  }
}
</script>